import { PagedResult, Result, SiteSearchResultItem } from "./../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    siteSection: string;
    siteSectionTitle: string;
    culture: string;

    constructor() {
        this.keywords = '';
        this.siteSection = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class SiteSearchService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<SiteSearchResultItem>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<SiteSearchResultItem>>({
            url: `/api/search/SearchSite`,
            method: "POST",
            data: payload
        });

        return result;
    }

    public static async getSuggestions(keywords: string): Promise<Result<Suggestion[]>> {

        var result = await this.requestJson<Suggestion[]>({
            url: `/api/search/SearchSiteSuggestions`,
            method: "POST",
            data: { keywords }
        });

        return result;
    }
}

export class Suggestion {
    value: string;
}


